import { render, staticRenderFns } from "./ModalStudentLoginHistory.vue?vue&type=template&id=71d278f9&scoped=true&lang=pug&"
import script from "./ModalStudentLoginHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentLoginHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d278f9",
  null
  
)

export default component.exports